import React from 'react';

const ErrorState = ({ title, message, onAction, actionLabel = 'Go Back' }) => {
  return (
    <div className="error-state">
      <div className="error-icon">❌</div>
      <h3>{title}</h3>
      <p>{message}</p>
      {onAction && (
        <button className="btn-primary" onClick={onAction}>
          {actionLabel}
        </button>
      )}
    </div>
  );
};

export default ErrorState;
